var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer-wrap flex-item-center"},[_c('span',[_vm._v("© 2025 AlSP-TW All Rights Reserved")])])])
}]

export { render, staticRenderFns }